import React, { useState } from "react";
import { Eye, EyeOff, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Lysogen from "../images/Lysogen.jpg";
import { changePassword } from "../service/ChangePasswordService";

export default function ChangePassword() {
    const navigate = useNavigate();
    const [form, setForm] = useState({ current: "", next: "", confirm: "" });
    const [show, setShow] = useState({ current: false, next: false, confirm: false });
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        setError("");
        setSuccess(false);
    };

    const toggle = (field) => setShow({ ...show, [field]: !show[field] });

    const handleSubmit = async () => {
        if (!form.current || !form.next || !form.confirm) {
            setError("Please fill in all fields.");
            return;
        }
        if (form.next !== form.confirm) {
            setError("New passwords do not match.");
            return;
        }
        if (form.next.length < 8) {
            setError("Password must be at least 8 characters.");
            return;
        }
        try {
            const res = await changePassword(true, form.current, form.next, form.confirm);
            if (res === true) {
                setSuccess(true);
                setForm({ current: "", next: "", confirm: "" });
            } else {
                setError("Incorrect current password.");
            }
        } catch {
            setError("Incorrect current password.");
        }
    };

    return (
        <div className="home-layout">
            <Sidebar activePage="Settings" />

            <main className="home-main settings-main">
                <Header />

                <div className="settings-split">
                    <div className="chpw-scroll">
                        <div className="chpw-page">
                            <button className="chpw-back" onClick={() => navigate("/settings")}>
                                <ArrowLeft size={14} />
                                Back to Settings
                            </button>

                            <div className="chpw-card">
                                <h1 className="chpw-heading">Change Password</h1>
                                <p className="chpw-sub">Choose a strong password you haven't used before.</p>

                                <div className="auth-fields">
                                    <div className="auth-field">
                                        <label className="upload-label">Current Password</label>
                                        <div className="auth-input-wrap">
                                            <input
                                                className="upload-input"
                                                type={show.current ? "text" : "password"}
                                                name="current"
                                                placeholder="••••••••"
                                                value={form.current}
                                                onChange={handleChange}
                                            />
                                            <button className="auth-eye-btn" onClick={() => toggle("current")} tabIndex={-1}>
                                                {show.current ? <EyeOff size={15} /> : <Eye size={15} />}
                                            </button>
                                        </div>
                                    </div>

                                    <div className="chpw-divider" />

                                    <div className="auth-field">
                                        <label className="upload-label">New Password</label>
                                        <div className="auth-input-wrap">
                                            <input
                                                className="upload-input"
                                                type={show.next ? "text" : "password"}
                                                name="next"
                                                placeholder="••••••••"
                                                value={form.next}
                                                onChange={handleChange}
                                            />
                                            <button className="auth-eye-btn" onClick={() => toggle("next")} tabIndex={-1}>
                                                {show.next ? <EyeOff size={15} /> : <Eye size={15} />}
                                            </button>
                                        </div>
                                    </div>

                                    <div className="auth-field">
                                        <label className="upload-label">Confirm New Password</label>
                                        <div className="auth-input-wrap">
                                            <input
                                                className="upload-input"
                                                type={show.confirm ? "text" : "password"}
                                                name="confirm"
                                                placeholder="••••••••"
                                                value={form.confirm}
                                                onChange={handleChange}
                                            />
                                            <button className="auth-eye-btn" onClick={() => toggle("confirm")} tabIndex={-1}>
                                                {show.confirm ? <EyeOff size={15} /> : <Eye size={15} />}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {error && <p className="chpw-error">{error}</p>}
                                {success && <p className="chpw-success">Password updated successfully.</p>}

                                <button className="start-analysis-btn" style={{ marginTop: 8 }} onClick={handleSubmit}>
                                    Update Password
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Right image panel */}
                    <div className="chpw-image-panel" style={{ backgroundImage: `url(${Lysogen})` }}>
                        <div className="settings-image-panel-overlay" />
                        <div className="settings-image-panel-caption">
                            <p className="featured-label">Science spotlight</p>
                            <p className="featured-title">Lysogen</p>
                            <p className="featured-authors">A detailed illustration of the lysogenic cycle</p>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
